import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import withTranslations from '../../utils/HighOrderComponent';
import { Button } from '@material-ui/core';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { mdulsAdminEmail } from '../../constants/globals';
import AuthenticationService from '../../securityUtils/AuthenticationService';
import { mailTrigger } from '../../utils';
import { connect } from 'react-redux';

class Dashboard extends Component {
  handleLoginClick = () => {
    !this.props.loggedUser.validToken && AuthenticationService.login();
  };

  onMailOpenHandler = () => {
    const { Email } = this.props.t;
    mailTrigger({
      recipient: mdulsAdminEmail,
      subject: Email.subject,
      body: Email.body,
    });
  };

  render() {
    const { loggedUser, t } = this.props || {},
      { Messages, Buttons } = t || {};
    const ifUserLoggedGoTo = loggedUser.validToken
      ? '/requestForSignetApproval'
      : '#';

    return (
      <div className="wrapper-fade-in-long">
        <div className="content-min-height w-75 dashboard_image"></div>
        <Container style={{ zIndex: 0 }} className="col-md-11 m-auto">
          <Row className="content-min-height">
            <Col md={4} className="dashboard_content_positioning">
              <div className="dashboard_content_positioning">
                <h5>
                  {Messages.message1 + ' '}
                  <strong className="eUprava-color">
                    {Messages.messageBold + ' '}
                  </strong>
                  {Messages.message2}
                </h5>
                <Link className="ml-auto mt-3" to={ifUserLoggedGoTo}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleLoginClick}
                  >
                    {Buttons?.message}
                  </Button>
                </Link>
              </div>
              <h5 className="eUprava-color">
                <div className="mb-3">{Messages.accessMessageQuestionPart}</div>
                <div className="mb-3">
                  {Messages.accessMessagePart + ' '}
                  <Link to="#" onClick={this.onMailOpenHandler}>
                    {Messages.linkMessage}
                  </Link>
                </div>
              </h5>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser || {},
});

export default connect(
  mapStateToProps,
  {}
)(withTranslations(Dashboard, 'Dashboard'));
